module.exports = __webpack_public_path__ + "d172a70cf57adf5e8199e47ef5f9392f.gif";